import { getFontWeight, getTextStyle } from "cms/theme/helpers";
import Styled from "styled-components";

export interface ContainerProps {
  $variant: "primary" | "magic";
}

export const Container = Styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => getTextStyle(props.theme, "L5")};
  color: ${(props) => props.theme.colors.neutrals.white500};
  height: 1.375rem;
  border-radius: 0.25rem;
  padding: 0 0.5rem;
  word-break: keep-all;
  white-space: nowrap;

  ${(props) =>
    props.$variant === "primary" &&
    `
      background-color: #1E90FF;
      background: radial-gradient(72.97% 270% at 50% 50%, #61B1FF 0%, #1E90FF 100%);
      box-shadow: 0px 2px 12px 0px rgba(97, 177, 255, 0.64), 0px 1px 1px 0px #61B1FF inset;
  `}

  ${(props) =>
    props.$variant === "magic" &&
    `
      background-color: #6419FF;
      background: radial-gradient(72.97% 270% at 50% 50%, #A881FE 0%, #6419FF 100%);
      box-shadow: 0px 2px 12px 0px rgba(168, 129, 254, 0.64), 0px 1px 1px 0px #A881FE inset;
    `}
`;
